/* =========================================================
   BUILD YOUR ROUTINE — FINAL (UPCART UI FAKE, SAFE)
========================================================= */

console.log('🔥 bundle.js loaded');

document.addEventListener('click', e => {
  const head = e.target.closest('.accordion_head');
  if (!head) return;
  const body = head.nextElementSibling;
  if (!body || !body.classList.contains('accordion_body')) return;
  const isOpen = body.style.display !== 'none';
  body.style.display = isOpen ? 'none' : 'block';
  const plusminus = head.querySelector('.plusminus');
  if (plusminus) {
    plusminus.textContent = isOpen ? '+' : '−';
  }
  head.classList.toggle('active', !isOpen);
});
/* =========================================================
   GLOBAL STATE
========================================================= */

window.BundleBuilder = {
  root: null,

  state: {
    tier: 3,
    discount: 15,
    items: []
  },

  els: {},

  init(root) {
    this.root = root;

    this.els.tierButtons  = root.querySelectorAll('.bundle-tier');
    this.els.slots        = root.querySelectorAll('[data-bundle-slot]');
    this.els.totalEl      = root.querySelector('[data-bundle-total]');
    this.els.originalEl   = root.querySelector('[data-bundle-original]');
    this.els.submitBtn    = root.querySelector('[data-bundle-submit]');
    this.els.productCards = root.querySelectorAll('[data-product-card]');

    this.bindTierButtons();
    this.bindGridButtons();
    this.render();
  },

  bindTierButtons() {
    this.els.tierButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        this.setTier(
          Number(btn.dataset.tier),
          Number(btn.dataset.discount)
        );
      });
    });
  },

  setTier(tier, discount) {
    this.state.tier = tier;
    this.state.discount = discount;

    this.els.tierButtons.forEach(b => b.classList.remove('active'));
    this.root
      .querySelector(`.bundle-tier[data-tier="${tier}"]`)
      ?.classList.add('active');

    this.render();
  },

  addItem(item) {
    if (this.state.items.length === 3 && this.state.tier === 3) {
      this.setTier(4, 20);
    }

    if (this.state.items.length >= this.state.tier) return false;

    this.state.items.push(item);
    this.render();
    return true;
  },

  removeItem(index) {
    this.state.items.splice(index, 1);

    if (this.state.items.length <= 3 && this.state.tier === 4) {
      this.setTier(3, 15);
    }

    this.render();
  },

  bindGridButtons() {
    this.els.productCards.forEach(card => {
      const btn = card.querySelector('[data-add-to-bundle]');
      if (!btn) return;

     btn.addEventListener('click', () => {
      this.addItem({
        variantId: Number(card.dataset.variantId),
        price: Number(card.dataset.price),
        html: card.querySelector('.bundle-product-image')?.innerHTML || '',
        variantLabel: card.querySelector('.variant-wrapper')?.innerHTML || '',
        title: card.querySelector('.product-title')?.innerHTML || ''
      });
    });
    });
  },

  render() {
    this.els.slots.forEach((slot, i) => {
      if (i === 3) {
        slot.classList.toggle('is-optional', this.state.tier < 4);
      }

      const inner = slot.querySelector('.bundle-slot-inner');
      inner.innerHTML = '';
if (this.state.items[i]) {
  const remove = document.createElement('button');
  remove.className = 'bundle-remove';
  remove.textContent = '×';
  remove.onclick = () => this.removeItem(i);

  inner.innerHTML = this.state.items[i].html;
  inner.appendChild(remove);

  const variantEl = slot.querySelector('.variant-wrapper');
  const titleEl = slot.querySelector('.product-title');
  if (variantEl) variantEl.innerHTML = this.state.items[i].variantLabel;
  if (titleEl) titleEl.innerHTML = this.state.items[i].title;
} else {
  inner.innerHTML = '<span> <a href="#bundlegrid"> Select product</a></span>';

  const variantEl = slot.querySelector('.variant-wrapper');
  const titleEl = slot.querySelector('.product-title');
  if (variantEl) variantEl.textContent = 'Scent';
  if (titleEl) titleEl.textContent = 'Product';
}
    });

    const original = this.state.items.reduce((t, i) => t + i.price, 0);
    const discounted = original * (1 - this.state.discount / 100);

   this.els.originalEl.textContent = money(original);
    this.els.totalEl.textContent = money(discounted);

    const savingsEl = this.root.querySelector('[data-bundle-savings]');
    if (savingsEl) {
      const saved = original - discounted;
      savingsEl.textContent = saved > 0 ? money(saved) + ' SAVED' : '';
    }

    const isFull = this.state.items.length === this.state.tier;
    this.els.submitBtn.disabled = !isFull;
    this.els.submitBtn.classList.toggle('active', isFull);
    this.els.submitBtn.textContent = isFull ? 'Add to Cart' : 'Select more products';
    updateStickyBanner();
  }
};

/* =========================================================
   CART ADD (SAFE)
========================================================= */

let CART_LOCK = false;

async function withCartLock(fn) {
  if (CART_LOCK) return;
  CART_LOCK = true;
  try {
    await fn();
  } finally {
    setTimeout(() => (CART_LOCK = false), 400);
  }
}

document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-bundle-submit]');
  if (!btn) return;

  await withCartLock(async () => {
    const groupId = `byr-${Date.now()}`;

    const items = BundleBuilder.state.items.map(item => ({
      id: item.variantId,
      quantity: 1,
      properties: {
        _bundle_group: groupId,
        _bundle_tier: String(BundleBuilder.state.tier)
      }
    }));

    console.group('📦 Bundle payload');
    console.table(items);
    console.groupEnd();

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('upcart:open'));
    }, 300);
  });
});
/* =========================================================
   UPCART UI FAKE DISCOUNTS (THIS IS THE MAGIC)
========================================================= */

/* =========================================================
   UPCART — FAKE BUNDLE DISCOUNT (UI ONLY)
========================================================= */

function applyBundleDiscountsToUpcart() {
  console.group('🎭 Applying bundle discounts (UI only)');

  const rows = document.querySelectorAll('.upcart-product-item');

  rows.forEach(row => {
    const hasBundle = row.querySelector(
      '.upcart-item-property span'
    );

    if (!hasBundle) return;

    const priceEl = row.querySelector('.upcart-item-price');
    if (!priceEl) return;

    // Prevent double-applying
    if (row.dataset.bundleDiscountApplied === 'true') return;

    const priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
    const original = parseFloat(priceText);
    if (!original) return;

    // Determine tier by counting grouped items
    const groupValue = hasBundle.textContent.trim();
    const grouped = document.querySelectorAll(
      `.upcart-item-property span:contains("${groupValue}")`
    ).length;

    let discount = 0;
    if (grouped >= 4) discount = 0.20;
    else if (grouped >= 3) discount = 0.15;
    else return;

    const discounted = (original * (1 - discount)).toFixed(2);

    // Build UI
    const wrapper = document.createElement('div');
    wrapper.className = 'upcart-bundle-price';

    wrapper.innerHTML = `
      <span style="text-decoration: line-through; opacity: 0.6; margin-right: 6px;">
        $${original.toFixed(2)}
      </span>
      <span style="font-weight: 600;">
        $${discounted}
      </span>
    `;

    priceEl.innerHTML = '';
    priceEl.appendChild(wrapper);

    row.dataset.bundleDiscountApplied = 'true';
  });

  console.groupEnd();
}


/* =========================================================
   UPCART HOOKS
========================================================= */

function hookUpcartBundleUI() {
  applyBundleDiscountsToUpcart();

  // Re-run when UpCart fires updates
  window.addEventListener(
    'aftersell-upcart:public-events:cart-updated',
    applyBundleDiscountsToUpcart
  );

  window.addEventListener(
    'aftersell-upcart:public-events:cart-loaded',
    applyBundleDiscountsToUpcart
  );
}

// Initial delay (UpCart mounts async)
setTimeout(hookUpcartBundleUI, 2000);

/* =========================================================
   DOM READY
========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-bundle-root]');
  if (root) BundleBuilder.init(root);
   initStickyObserver();
});

/* =========================================================
   QUICK VIEW (PRESERVED — DO NOT TOUCH)
========================================================= */

const quickViewModal   = document.querySelector('[data-quick-view-modal]');
const quickViewContent = document.querySelector('[data-quick-view-content]');

function closeQuickView() {
  quickViewModal.hidden = true;
  quickViewContent.innerHTML = '';
}

document.addEventListener('click', e => {
  if (e.target.closest('[data-quick-view-close]')) {
    closeQuickView();
  }
});

document.addEventListener('click', async e => {
  const trigger = e.target.closest('[data-quick-view]');
  if (!trigger) return;

  quickViewModal.hidden = false;
  quickViewContent.innerHTML = '<div class="quick-view-loader"><div class="spinner"></div></div>';

  const res = await fetch(
    `/products/${trigger.dataset.productHandle}?section_id=bundle-quickview`
  );

  quickViewContent.innerHTML = await res.text();

  // Initialize Swiper after content loads
  const swiperEl = quickViewContent.querySelector('.product-swiper');
  if (swiperEl && typeof Swiper !== 'undefined') {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }
});

document.addEventListener('click', e => {
  const btn = e.target.closest('[data-quick-add-to-bundle]');
  if (!btn) return;

  const productRoot = btn.closest('[data-quick-view-product]');
  if (!productRoot) return;

  const variantId = Number(btn.dataset.variantId);
  const price = Number(btn.dataset.price || 0);

  if (!variantId) return;

 const img = productRoot.querySelector('.swiper-slide:first-child .product-image');

BundleBuilder.addItem({
  variantId: variantId,
  price: price,
  html: img ? img.outerHTML : '',
  variantLabel: productRoot.querySelector('.variant-wrapper')?.innerHTML?.trim() || '<span class="quinary redirect-kicker micro-text">Tropical</span>',
  title: productRoot.querySelector('.product__title a')?.textContent?.trim() || ''
});

  closeQuickView();
});


/* =========================================================
   MOBILE STICKY BANNER
========================================================= */

let stickyObserver = null;
let stickyVisible = false;

function initStickyObserver() {
  const banner = document.getElementById('bundle-sticky-banner');
  const slotsContainer = document.querySelector('[data-bundle-slots]');
  if (!banner || !slotsContainer) return;

  function checkVisibility() {
    const rect = slotsContainer.getBoundingClientRect();
    const wasVisible = stickyVisible;
    stickyVisible = rect.bottom < 0 || rect.top > window.innerHeight;
    if (wasVisible !== stickyVisible) updateStickyBanner();
  }

  window.addEventListener('scroll', checkVisibility, { passive: true });
  checkVisibility();
}
function updateStickyBanner() {
  const banner = document.getElementById('bundle-sticky-banner');
  if (!banner) return;

  const isMobile = window.innerWidth <= 768;
  const shouldShow = isMobile && stickyVisible;

  banner.classList.toggle('active', shouldShow);

  const stickySlots = banner.querySelectorAll('[data-sticky-slot]');
  stickySlots.forEach((slot, i) => {
    const inner = slot.querySelector('.bundle-sticky-slot-inner');

    if (i === 3) {
      slot.classList.toggle('is-optional', BundleBuilder.state.tier < 4);
    }

    if (BundleBuilder.state.items[i]) {
      inner.innerHTML = BundleBuilder.state.items[i].html;
      slot.classList.add('filled');
    } else {
      inner.innerHTML = '';
      slot.classList.remove('filled');
      slot.classList.remove('removing');
    }
  });

  const totalEl = banner.querySelector('[data-sticky-total]');
  const originalEl = banner.querySelector('[data-sticky-original]');
  const discountEl = banner.querySelector('[data-sticky-discount]');
  const cartBtn = document.getElementById('bundle-sticky-cart');

  if (totalEl && originalEl) {
    const original = BundleBuilder.state.items.reduce((t, i) => t + i.price, 0);
    const discounted = original * (1 - BundleBuilder.state.discount / 100);
    originalEl.textContent = money(original);
    totalEl.textContent = money(discounted);
    originalEl.style.display = original > 0 ? 'inline' : 'none';
  }

  if (discountEl) {
    const count = BundleBuilder.state.items.length;
    if (count >= 4) {
      discountEl.textContent = '4 for 20% Off';
    } else if (count >= 3) {
      discountEl.textContent = '3 for 15% Off';
    } else {
      discountEl.textContent = count + ' / 3 for 15% Off';
    }
  }

  if (cartBtn) {
    const isFull = BundleBuilder.state.items.length === BundleBuilder.state.tier;
    cartBtn.disabled = !isFull;
  }
}

/* Sticky slot tap to toggle remove button */
document.addEventListener('click', e => {
  const slot = e.target.closest('[data-sticky-slot]');
  if (!slot) return;
  if (e.target.closest('[data-sticky-remove]')) return;
  if (!slot.classList.contains('filled')) return;

  const wasRemoving = slot.classList.contains('removing');
  document.querySelectorAll('.bundle-sticky-slot.removing').forEach(s => s.classList.remove('removing'));
  if (!wasRemoving) {
    slot.classList.add('removing');
  }
});

/* Sticky remove button */
document.addEventListener('click', e => {
  const removeBtn = e.target.closest('[data-sticky-remove]');
  if (!removeBtn) return;

  const index = Number(removeBtn.dataset.stickyRemove);
  BundleBuilder.removeItem(index);
});

/* Sticky cart button */
document.addEventListener('click', e => {
  const cartBtn = e.target.closest('#bundle-sticky-cart');
  if (!cartBtn || cartBtn.disabled) return;

  const mainBtn = document.querySelector('[data-bundle-submit]');
  if (mainBtn) mainBtn.click();
});

/* Close removing state when tapping elsewhere */
document.addEventListener('click', e => {
  if (!e.target.closest('[data-sticky-slot]')) {
    document.querySelectorAll('.bundle-sticky-slot.removing').forEach(s => s.classList.remove('removing'));
  }
});
/* =========================================================
   HELPERS
========================================================= */

function money(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}
